import Phaser from 'phaser'
import { getMetaProgression } from '../systems/MetaProgression'
import { audioManager } from '../audio/AudioManager'
import { t, toggleLang } from '../../i18n'
import { hapticImpactLight, setTelegramBackButton } from '../../telegram/webApp'

export class MenuScene extends Phaser.Scene {
  private muteBtn: Phaser.GameObjects.Text | null = null

  constructor() {
    super({ key: 'Menu' })
  }

  create() {
    const { width, height } = this.scale
    const meta = getMetaProgression()
    this.cameras.main.fadeIn(220, 0, 0, 0)

    // Telegram: no back button on Menu (root scene)
    setTelegramBackButton(null)

    this.add
      .text(width / 2, height / 2 - 60, `⚡ ${t('menu.title')}`, {
        fontSize: '32px',
        color: '#ffffff',
        fontStyle: 'bold',
      })
      .setOrigin(0.5)

    this.add
      .text(width / 2, height / 2 - 14, `${t('menu.coins')}: ${meta.getCoins()}`, {
        fontSize: '20px',
        color: '#ffdd44',
      })
      .setOrigin(0.5)

    const playBtn = this.add
      .text(width / 2, height / 2 + 20, t('menu.play'), {
        fontSize: '26px',
        color: '#00ff88',
        backgroundColor: '#16213e',
        padding: { x: 24, y: 12 },
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })

    playBtn.on('pointerdown', () => {
      audioManager.play('buttonClick')
      hapticImpactLight()
      this.transitionTo('Game')
    })

    playBtn.on('pointerover', () => playBtn.setStyle({ color: '#ffffff' }))
    playBtn.on('pointerout', () => playBtn.setStyle({ color: '#00ff88' }))

    const shopBtn = this.add
      .text(width / 2, height / 2 + 92, t('menu.shop'), {
        fontSize: '24px',
        color: '#44aaff',
        backgroundColor: '#16213e',
        padding: { x: 24, y: 10 },
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })

    shopBtn.on('pointerdown', () => {
      audioManager.play('buttonClick')
      hapticImpactLight()
      this.transitionTo('Shop')
    })
    shopBtn.on('pointerover', () => shopBtn.setStyle({ color: '#ffffff' }))
    shopBtn.on('pointerout', () => shopBtn.setStyle({ color: '#44aaff' }))

    const langBtn = this.add
      .text(width - 12, 12, t('menu.lang'), {
        fontSize: '18px',
        color: '#ffffff',
        backgroundColor: '#16213e',
        padding: { x: 12, y: 8 },
      })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true })
      .setDepth(20)

    langBtn.on('pointerdown', () => {
      toggleLang()
      this.scene.restart()
    })
  }

  private transitionTo(sceneKey: string): void {
    this.cameras.main.fadeOut(220, 0, 0, 0)
    this.time.delayedCall(220, () => this.scene.start(sceneKey))
  }
}
